// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7506":"css/admin-app.6751","7887":"css/app.6751"}[chunkId] + ".css";
};